import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Form, Select, Radio, Checkbox } from 'antd';
import { toString, forEach, replace, keys, keyBy, filter, get } from 'lodash';
import validator from 'validator';
import { connect } from 'react-redux';
import { getCountryCallingCode } from 'libphonenumber-js';
import ReactCountryFlag from 'react-country-flag';
import { StyledRadioGroupHorizontal } from 'components/Styled';

import helpers from 'utils/helpers';
import { getCategoriesRequest } from 'ducks/shipments';
import { updateInfoRequest } from 'ducks/auth';
import {
  FormTitle,
  StyledCol,
  StyledFormItem,
  StyledInput,
  StyledSelect,
  StyledButton
} from 'components/Styled';
import countries from 'data/countries';

const { Option } = Select;

const avgShipmentsList = [
  { min: null, max: 10 },
  { min: 10, max: 20 },
  { min: 20, max: 40 },
  { min: 40, max: 60 },
  { min: 60, max: null }
];

const avgWeightList = [
  { min: null, max: 1 },
  { min: 1, max: 2.5 },
  { min: 2.5, max: 5 },
  { min: 6, max: 10 },
  { min: 11, max: 15 },
  { min: 16, max: 20 },
  { min: 21, max: 44 },
  { min: 45, max: 70 },
  { min: 71, max: 99 },
  { min: 99, max: null }
];

class Basic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      phone: '',
      phoneCc: '852',
      country: 'HK',
      userType: 'personal',
      company: '',
      avgShipments: undefined,
      avgWeight: undefined,
      categories: undefined,
      categoryDescription: ''
    };
  }

  gtmEvents = {
    // reserve use
    // email: `Inputted Login Email`
  };

  handleTextInputChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        loginInput: toString(this.state[name])
      });
    }

    this.setState({
      [name + 'Status']: this.validateError(name) ? 'error' : '',
      [name + 'Help']: this.validateError(name)
    });
  };

  handleInputChange = (value, name) => {
    this.setState(
      {
        [name]: value
      },
      () => {
        this.setState({
          [name + 'Status']: this.validateError(name) ? 'error' : '',
          [name + 'Help']: this.validateError(name)
        });
      }
    );
  };

  getValidateType = name => {
    const type = {
      name: 'chars',
      phone: 'phone',
      company: this.state.userType === 'business' ? 'required' : 'optional',
      avgShipments:
        this.state.userType === 'business' ? 'required' : 'optional',
      avgWeight: this.state.userType === 'business' ? 'required' : 'optional',
      categories: this.state.userType === 'business' ? 'required' : '',
      categoryDescription:
        this.state.categories === null ? 'string' : 'optional'
    };

    return type[name];
  };

  validate = () => {
    const fields = [
      'name',
      'phone',
      'company',
      'avgShipments',
      'avgWeight',
      'categories',
      'categoryDescription'
    ];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        return false;
      }
    }
    return true;
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    if (name === 'categories' && this.state[name] === null) {
      return null;
    }

    switch (this.getValidateType(name)) {
      case 'optional':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return null;
        }

        if (!patterns.test(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;
      case 'required':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;
      case 'chars':
        patterns = /^[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;
      case 'phone':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!validator.isMobilePhone(replace(value, /\s/g, ''))) {
          return `auth.err_msg.${name}.format`;
        }

        return null;
      case 'string':
        patterns = /([0-9a-z\s\-.,/'"():;$&@!?]|\p{Script=Hani})+/gu;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;

      default:
        return null;
    }
  };

  handleAction = () => {
    if (!this.validate()) {
      return helpers.scrollToError('.ant-drawer-body');
    }

    const minAvgShipments = get(
      avgShipmentsList[this.state.avgShipments],
      'min'
    );
    const maxAvgShipments = get(
      avgShipmentsList[this.state.avgShipments],
      'max'
    );
    const minAvgWeight = get(avgWeightList[this.state.avgWeight], 'min');
    const maxAvgWeight = get(avgWeightList[this.state.avgWeight], 'max');

    this.props.updateInfoRequest({
      name: this.state.name,
      phone: this.state.phone,
      phoneCc: this.state.phoneCc,
      company: this.state.company,
      userType: this.state.userType,
      minAvgShipments,
      maxAvgShipments,
      minAvgWeight,
      maxAvgWeight,
      categories: this.state.categories,
      categoryDescription: this.state.categoryDescription,
      whatsapp: this.state.whatsapp
    });
  };

  onRadioChange = e => {
    this.setState({
      userType: e.target.value
    });
  };

  onWhatsappCheckChange = e => {
    this.setState({
      whatsapp: e.target.checked
    });
  };

  componentDidMount() {
    this.props.getCategoriesRequest();

    this.setState({
      name: this.props.name,
      phone: this.props.phone,
      phoneCc: this.props.phoneCc,
      userType: this.props.userType || 'personal'
    });

    window.dataLayer.push({
      event: 'Land Basic'
    });
  }

  render() {
    const phoneCountry = keys(keyBy(this.props.countries, 'alpha-2'))
      .map(x => {
        const value = getCountryCallingCode(x);
        const flag = (
          <ReactCountryFlag
            countryCode={x}
            style={{ width: 20, height: 20, padding: '0 8px 4px 0' }}
            svg
          />
        );
        const label = `+${value}`;
        return { key: x, label, value, flag };
      })
      .sort((a, b) => a.value - b.value);
    return (
      <div
        style={{
          backgroundColor: '#fafafa',
          minHeight: '100%'
        }}>
        <div style={{ padding: '50px 0 45px', textAlign: 'center' }}>
          <div style={{ fontSize: '20px', fontWeight: 700 }}>
            {this.props.t('auth.form.contact_method')}
          </div>
          <div style={{ fontSize: '12px', paddingTop: '5px' }}>
            {this.props.t('auth.form.contact_text')}
          </div>
        </div>
        <Form>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            <StyledCol>
              <FormTitle>{this.props.t('auth.form.name')}</FormTitle>
              <StyledFormItem
                validateStatus={this.props.t(this.state['nameStatus']) || ''}
                help={this.props.t(this.state['nameHelp'])}>
                <StyledInput
                  size="large"
                  disabled={this.props.loading}
                  value={this.state['name']}
                  onChange={e => {
                    this.handleTextInputChange(e.target.value, 'name');
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('name');
                  }}
                />
              </StyledFormItem>
            </StyledCol>
          </Row>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            <StyledCol>
              <StyledRadioGroupHorizontal
                disabled={this.props.loading}
                onChange={this.onRadioChange}
                value={this.state.userType}>
                <Radio value="personal">
                  <span style={{ fontWeight: 700 }}>
                    {this.props.t('auth.form.personal')}
                  </span>
                </Radio>
                <Radio value="business">
                  <span style={{ fontWeight: 700 }}>
                    {this.props.t('auth.form.business')}
                  </span>
                </Radio>
              </StyledRadioGroupHorizontal>
            </StyledCol>
          </Row>
          {this.state.userType === 'business' && (
            <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
              <StyledCol>
                <FormTitle>{this.props.t('auth.form.company')}</FormTitle>
                <StyledFormItem
                  validateStatus={this.state['companyStatus'] || ''}
                  help={this.props.t(this.state['companyHelp'])}>
                  <StyledInput
                    size="large"
                    disabled={this.props.loading}
                    value={this.state['company']}
                    onChange={e => {
                      this.handleTextInputChange(e.target.value, 'company');
                    }}
                    onBlur={e => {
                      this.handleTextInputBlur('company');
                    }}
                  />
                </StyledFormItem>
              </StyledCol>
            </Row>
          )}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            <StyledCol flex={1}>
              <FormTitle>{this.props.t('auth.form.phone')}</FormTitle>
              <StyledFormItem>
                <StyledSelect
                  size="large"
                  disabled={this.props.loading}
                  value={`${this.state['country']}_${this.state['phoneCc']}`}
                  onChange={val => {
                    const arr = val.split('_');
                    this.handleTextInputChange(arr[0], 'country');
                    this.handleTextInputChange(arr[1], 'phoneCc');
                  }}>
                  {phoneCountry.map((x, i) => (
                    <Option
                      key={`${x.key}_${x.value}_${i}`}
                      value={`${x.key}_${x.value}`}
                      title={x.label}>
                      <div>
                        {x.flag}
                        {x.label}
                      </div>
                    </Option>
                  ))}
                </StyledSelect>
              </StyledFormItem>
            </StyledCol>
            <StyledCol flex={2}>
              <FormTitle style={{ height: 27 }} />
              <StyledFormItem
                validateStatus={this.state['phoneStatus'] || ''}
                help={this.props.t(this.state['phoneHelp'])}>
                <StyledInput
                  size="large"
                  disabled={this.props.loading}
                  value={this.state['phone']}
                  onChange={e => {
                    const val = e.target.value.replace(/[^0-9]/i, '');
                    this.handleTextInputChange(val, 'phone');
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('phone');
                  }}
                />
              </StyledFormItem>
            </StyledCol>
          </Row>
          {this.state.userType === 'business' && (
            <>
              <Row type="flex" style={{ paddingTop: '20px' }}>
                <StyledCol>
                  <FormTitle>
                    {this.props.t('auth.form.avg_shipments')}
                  </FormTitle>
                  <StyledFormItem
                    validateStatus={this.state['avgShipmentsStatus'] || ''}
                    help={this.props.t(this.state['avgShipmentsHelp'])}>
                    <StyledSelect
                      size="large"
                      disabled={this.props.loading}
                      value={this.state['avgShipments']}
                      placeholder={this.props.t('common.select')}
                      onChange={val => {
                        this.handleInputChange(val, 'avgShipments');
                      }}>
                      {avgShipmentsList.map((x, i) => (
                        <Option key={x.max} value={i} title={x.max}>
                          <div>
                            {(() => {
                              if (!x.min) {
                                return this.props.t(
                                  'auth.form.avg_shipments_label_below',
                                  {
                                    max: x.max
                                  }
                                );
                              }

                              if (!x.max) {
                                return this.props.t(
                                  'auth.form.avg_shipments_label_above',
                                  {
                                    min: x.min
                                  }
                                );
                              }

                              return `${this.props.t(
                                'auth.form.avg_shipments_label',
                                {
                                  min: x.min,
                                  max: x.max
                                }
                              )}`;
                            })()}
                          </div>
                        </Option>
                      ))}
                    </StyledSelect>
                  </StyledFormItem>
                </StyledCol>
              </Row>
              <Row type="flex" style={{ paddingTop: '20px' }}>
                <StyledCol>
                  <FormTitle>{this.props.t('auth.form.avg_weight')}</FormTitle>
                  <StyledFormItem
                    validateStatus={this.state['avgWeightStatus'] || ''}
                    help={this.props.t(this.state['avgWeightHelp'])}>
                    <StyledSelect
                      size="large"
                      disabled={this.props.loading}
                      value={this.state['avgWeight']}
                      placeholder={this.props.t('common.select')}
                      onChange={val => {
                        this.handleInputChange(val, 'avgWeight');
                      }}>
                      {avgWeightList.map((x, i) => (
                        <Option key={x.max} value={i} title={x.max}>
                          <div>
                            {(() => {
                              if (!x.min) {
                                return this.props.t(
                                  'auth.form.avg_weight_label_below',
                                  {
                                    max: x.max
                                  }
                                );
                              }

                              if (!x.max) {
                                return this.props.t(
                                  'auth.form.avg_weight_label_above',
                                  {
                                    min: x.min
                                  }
                                );
                              }

                              return `${this.props.t(
                                'auth.form.avg_weight_label',
                                {
                                  min: x.min,
                                  max: x.max
                                }
                              )}`;
                            })()}
                          </div>
                        </Option>
                      ))}
                    </StyledSelect>
                  </StyledFormItem>
                </StyledCol>
              </Row>
              <Row type="flex" style={{ paddingTop: '20px' }}>
                <StyledCol>
                  <FormTitle>{this.props.t('auth.form.categories')}</FormTitle>
                  <StyledFormItem
                    validateStatus={this.state['categoriesStatus'] || ''}
                    help={this.props.t(this.state['categoriesHelp'])}>
                    <StyledSelect
                      size="large"
                      disabled={!this.props.categories}
                      value={this.state['categories']}
                      placeholder={this.props.t('common.select')}
                      onChange={val => {
                        this.handleInputChange(val, 'categories');
                      }}>
                      {filter(this.props.categories, ['parent', null]).map(
                        x => (
                          <Option
                            key={x.key}
                            value={x.key !== 'others' ? x.id : null}
                            title={x.name[this.props.t('key')]}>
                            {x.name[this.props.t('key')]}
                          </Option>
                        )
                      )}
                    </StyledSelect>
                  </StyledFormItem>
                </StyledCol>
              </Row>
              {this.state.categories === null && (
                <Row type="flex" style={{ paddingTop: '13px' }}>
                  <StyledCol>
                    <StyledFormItem
                      validateStatus={
                        this.state['categoryDescriptionStatus'] || ''
                      }
                      help={this.props.t(
                        this.state['categoryDescriptionHelp']
                      )}>
                      <StyledInput
                        size="large"
                        disabled={this.props.loading}
                        value={this.state['categoryDescription']}
                        placeholder={this.props.t(
                          'auth.form.categories_example_placeholder'
                        )}
                        onChange={e => {
                          this.handleTextInputChange(
                            e.target.value,
                            'categoryDescription'
                          );
                        }}
                        onBlur={e => {
                          this.handleTextInputBlur('categoryDescription');
                        }}
                      />
                    </StyledFormItem>
                  </StyledCol>
                </Row>
              )}
            </>
          )}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            <StyledCol>
              <Checkbox
                onChange={this.onWhatsappCheckChange}
                disabled={this.props.loading}>
                {this.props.t('auth.form.whatsapp_label')}
              </Checkbox>
            </StyledCol>
          </Row>
          <Row type="flex" gutter={14} style={{ padding: '15px 0' }}>
            <StyledCol>
              <StyledButton
                onClick={this.handleAction}
                type="primary"
                loading={this.props.loading}
                htmlType="submit"
                shadow
                block>
                {this.props.t('button.confirm')}
              </StyledButton>
            </StyledCol>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.auth.loading,
    updateBasicSuccess: !!state.auth.updateBasicSuccess,
    name: state.auth.name || '',
    phone: state.auth.phone || '',
    phoneCc: state.auth.phoneCc || '852',
    userType: state.auth.userType || null,
    categories: state.shipments.categories,
    countries: state.shipments.countries || countries
  };
};

const mapDispatchToProps = {
  updateInfoRequest,
  getCategoriesRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Basic)
);
